export function extractTypeToArray<T>(item: T): (keyof T)[] {
    const keyList: (keyof T)[] = []
    let objectKey: keyof T;
    for (objectKey in item) {
        keyList.push(objectKey)
    }

    return keyList;
}
